import React, { useState } from "react";
import styles from "./HomeFooter.module.css";
import logo from "../../assets/img/LogoABA.png";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

const HomeFooter = () => {

    const [activeDialog, setActiveDialog] = useState(false);

    return (
        <div className={styles.homeFooter}>
            <div className={styles.contentBoxAddress}>
                <img className={styles.logo} src={logo} alt="logo" />
                <p style={{ fontWeight: "600", lineHeight: "1" }}>Dirección:</p>
                <div className={styles.addressText}>
                    <p>Av. Winston Churchill, esquina Paseo de los Locutores, Torre Corporativa Hábitat Center piso 6, sector Piantini.</p>
                </div>
                <p>Santo Domingo, República Dominicana</p>
                <p style={{ fontWeight: "600", lineHeight: "1" }}>Teléfonos:</p>
                <p>809-541-5211 | 809-541-5219</p>
            </div>
            <div className={styles.contentBoxSocialNetworks}>
                {/* <p style={{ fontSize: "1.5rem", fontWeight: "600", lineHeight: "1" }}>Redes sociales:</p> */}

                <div className={styles.socialMedia}>
                    {/* <Button className={styles.courseraButton}></Button> */}
                    {/* <p onClick={() => setActiveDialog(true)} className={styles.termsAndConditions}>Términos y condiciones</p> */}
                    <Button className={styles.linkedinButton} onClick={() => (window.location.href = "https://www.linkedin.com/company/aulaaba/posts/?feedView=all")} ></Button>
                    <Button
                        onClick={() => (window.location.href = "https://www.instagram.com/aulaaba/")}
                        icon="pi pi-instagram"
                        className={styles.instagramButton}
                    />
                </div>
            <Dialog header="Términos y condiciones" onHide={() => setActiveDialog(false)} visible={activeDialog} className={styles.dialog}>

            </Dialog>
            </div>
        </div>
    );
};

export default HomeFooter;